import React, { useRef, useState, useEffect } from 'react';
import moment from 'moment';
import {
  StructuredGenerate,
  DynamicDropDownInput,
  DynamicNumericInput,
  DynamicDateInput,
  DynamicTextInput,
  DynamicCheckBoxInput,
  DynamicHiddenInput,
  DynamicButtonInput
} from '../software-dynamic-version-3/mainSection-multiple-inputs-v-3';
import DynamicInputGrid from '../software-dynamic-version-3/popup-input-grid-v-3';
import AddNewDialog from '../software-dynamic-version-3/addNew-popup-list-v-3';
import './purchase-invoice-list.scss';

import PurchaseInvoiceService from './purchase-invoice.service';
import securityService from '../security/security.service';

const PurchaseInvoiceAdd = (props) => {
  let { DynamicDropDownInput: DropdownComponent, DynamicNumericInput: NumberComponent, DynamicDateInput: DateComponent, DynamicTextInput: TextComponent, DynamicCheckBoxInput: CheckBoxComponent, DynamicHiddenInput: HiddenComponent, DynamicButtonInput: ButtonComponent } = { DynamicDropDownInput, DynamicNumericInput, DynamicDateInput, DynamicTextInput, DynamicCheckBoxInput, DynamicHiddenInput, DynamicButtonInput };

  // Utility to update main section values
  const updateMainSecionsValue = (valueObj) => {
    setInputProps((prevValues) => {
      const updatedValues = { ...prevValues };
      Object.keys(valueObj).forEach((key) => {
        if (updatedValues[key]) {
          updatedValues[key] = {
            ...updatedValues[key],
            ...valueObj[key],
          };
        }
      });
      return updatedValues;
    });
  };

  // State initialization for main form fields
  const [inputProps, setInputProps] = useState({
    CallBelowGridDataSource: { name: 'CallBelowGridDataSource', value: props.isAdd === false },
    SelectRowByID: { name: 'SelectRowByID', value: undefined },
    PurchaseInvoiceID: { name: 'PurchaseInvoiceID', value: props.PurchaseInvoiceID || undefined },
    CompanyID: { name: 'CompanyID', value: props.CompanyID || securityService.getCompanyIDLoggedInUserId() },
    PurchaseInvoiceDate: { name: 'PurchaseInvoiceDate', caption: 'Invoice Date', value: props.PurchaseInvoiceDate || 'currentDate' },
    CostCenter: {
      name: { id: 'CostCenterID', value: 'CostCenter' },
      caption: 'Select Cost Center',
      value: { id: props.CostCenterID || 'undefined', value: props.CostCenter || '' },
      dataSource: { type: 'Route', route: 'CostCenter' },
      addNew: { Route: 'CostCenter', Security: 'CostCenter' }
    },
    AccountTitleVendor: {
      name: { id: 'AccountIDVendor', value: 'AccountTitleVendor' },
      caption: 'Select Vendor',
      value: { id: props.AccountIDVendor || 'undefined', value: props.AccountTitleVendor || '' },
      dataSource: { type: 'Route', route: 'AccountIDVendor' },
      addNew: { Route: 'AgentAccounts', Security: 'Agent Accounts' },

    },
    AccountTitleExpense: {
      name: { id: 'AccountIDExpense', value: 'AccountTitleExpense' },
      caption: 'Select Expense Account',
      value: { id: props.AccountIDExpense || 'undefined', value: props.AccountTitleExpense || '' },
      dataSource: { type: 'Route', route: 'AccountIDExpense' },
      addNew: { Route: 'ExpenseAccounts', Security: 'ExpenseAccounts' },
    },
    PaymentDays: { name: 'PaymentDays', caption: 'Payment Days', value: props.PaymentDays || 0, decimal: 0 },
    ReferenceInvoiceNo: { name: 'ReferenceInvoiceNo', caption: 'Reference Invoice No', value: props.ReferenceInvoiceNo || '-' },
    TRNNo: { name: 'TRNNo', caption: 'TRN No', value: props.TRNNo || '' },
    PreparedBy: { name: 'PreparedBy', caption: 'Prepared By', value: props.PreparedBy || '-' },
  });

  useEffect(() => {
    if (props.isAdd === false) {
      setTimeout(() => {
        CallBelowGridDataSources();
      }, 300);
    }
  }, []);

  // Input event handlers
  const handleInputCreated = async (e, name) => {
    console.log(e);
    console.log(`Input ${name} changed to ${e}`);
  };
  const handleInputFocus = async (e, name) => {
    console.log(e);
    console.log(`Input ${name} focus to ${e}`);
  };
  const handleInputChange = async (value, name) => {
    if(name === 'AccountTitleVendor'){
      PurchaseInvoiceService.getTRNNo(value.id)
      .then((response) => {
        console.log(response);
      updateMainSecionsValue({TRNNo:{value:response.data.recordset[0].TRNNo}})
      })
      .catch((error) => {
        console.log(error);
      });
    }
    console.log(value);
    console.log(`Input ${name} changed to ${value}`);
  };
  const handleInputBlur = async  (value, name) => {
    if(name == 'PreparedBy'){
      setTimeout(()=>document.getElementById('PurchaseInvoiceDetailGrid_add').click(),100)
    }
  };

  // Main section input list
  let inputsList = [
    { Input: HiddenComponent, Props: { ...inputProps.PurchaseInvoiceID, setInputProps }, ColumnSize: 0 },
    { Input: HiddenComponent, Props: { ...inputProps.CompanyID, setInputProps }, ColumnSize: 0 },
    { Input: DateComponent, Props: { ...inputProps.PurchaseInvoiceDate, setInputProps }, ColumnSize: 4 },
    { Input: DropdownComponent, Props: { ...inputProps.CostCenter, setInputProps }, ColumnSize: 4 },
    { Input: DropdownComponent, Props: { ...inputProps.AccountTitleVendor, setInputProps,onChange:handleInputChange }, ColumnSize: 4 },
    { Input: DropdownComponent, Props: { ...inputProps.AccountTitleExpense, setInputProps }, ColumnSize: 4 },
    { Input: NumberComponent, Props: { ...inputProps.PaymentDays, setInputProps }, ColumnSize: 4 },
    { Input: TextComponent, Props: { ...inputProps.ReferenceInvoiceNo, setInputProps }, ColumnSize: 4 },
    { Input: TextComponent, Props: { ...inputProps.TRNNo, setInputProps }, ColumnSize: 4 },
    { Input: TextComponent, Props: { ...inputProps.PreparedBy, setInputProps,onFocus:handleInputFocus,onBlur:handleInputBlur }, ColumnSize: 4 },
  ];

  // Utility to refresh below grid data source
  let CallBelowGridDataSources = () => {
    setInputProps((prevValues) => ({
      ...prevValues,
      ['CallBelowGridDataSource']: { ...prevValues['CallBelowGridDataSource'], value: true }
    }));
    setTimeout(() => {
      setInputProps((prevValues) => ({
        ...prevValues,
        ['CallBelowGridDataSource']: { ...prevValues['CallBelowGridDataSource'], value: false }
      }));
    }, 300);
  };

  const onClosing = (e)=>{
    CallBelowGridDataSources()
    // setTimeout(() => {
    //   if(e ==  'PropertyName'){
    //     document.getElementById('TenantContractFS_PropertyDetailGrid_add').click()
        
    //   }else  if(e ==  'ModeOfPayment'){
    //     document.getElementById('TenantContractFS_PaymentDetailGrid_add').click()
        
    //   }
    // }, 300);
    }

  // Grid columns for PurchaseInvoice_Detail
  let BelowGridColumns = [
    { field: "PurchaseInvoiceDetailID", headerText: 'Detail ID', width: '150px', textAlign: 'right', headerTextAlign: 'center', other: [{ visible: false }] },
    { field: "PurchaseInvoiceID", headerText: 'Invoice ID', width: '150px', textAlign: 'right', headerTextAlign: 'center', other: [{ visible: false }] },
    // { field: "ProductID", headerText: 'Product', width: '200px', textAlign: 'left', headerTextAlign: 'center', other: [{ editType: 'dropdownedit', edit: { 
    // caption: 'Product', source: { type: "Route", dataSource: 'Product' }, field: { id: 'ProductID', value: 'ProductName' }, filter: {} } }] },
    { field:"ProductName",headerText:'Product',width:'200px',textAlign:'left' ,headerTextAlign:'center',other:[{'editType':'dropdownedit',edit:{
      caption:'Product' ,source:{type:"Route",dataSource:'Product'} , field:{id:'ProductID',value:'ProductName'}, filter:{},
    }}]
    },
    { field: "PurchaseQuantity", headerText: 'Quantity', width: '130px', textAlign: 'right', headerTextAlign: 'center', other: [{ initialValue: 0, format: 'n0', edit: { format: 'n0' }, editType: 'numericedit', allowEditing: true }] },
    { field: "PurchaseRate", headerText: 'Rate', width: '130px', textAlign: 'right', headerTextAlign: 'center', other: [{ initialValue: 0, format: 'n2', edit: { format: 'n2' }, editType: 'numericedit', allowEditing: true }] },
    { field: "PurchaseAmount", headerText: 'Amount', width: '150px', textAlign: 'right', headerTextAlign: 'center', other: [{ initialValue: 0, format: 'n2', edit: { format: 'n2' }, editType: 'numericedit', allowEditing: true }] },
    { field: "TaxPercent", headerText: 'Tax %', width: '120px', textAlign: 'right', headerTextAlign: 'center', other: [{ initialValue: 0, format: 'n2', edit: { format: 'n2' }, editType: 'numericedit', allowEditing: true }] },
    { field: "TaxAmount", headerText: 'Tax Amount', width: '130px', textAlign: 'right', headerTextAlign: 'center', other: [{ initialValue: 0, format: 'n2', edit: { format: 'n2' }, editType: 'numericedit', allowEditing: true }] },
    { field: "TotalAmount", headerText: 'Total Amount', width: '150px', textAlign: 'right', headerTextAlign: 'center', other: [{ initialValue: 0, format: 'n2', edit: { format: 'n2' }, editType: 'numericedit', allowEditing: true, endEdit:true }] },
  ];

  // Grid event handler for calculations and save logic
  const actionComplete = async (
    grid,
    args,
    setDataSourceState,
    getListService,
    selectedRow,
    selectRowByID,
    startEdit,
    addUserLog,
    editUserLog,
    dataSourceStateLength
  ) => {
    console.log("selectedRow",selectedRow)
    console.log("args",args)
    console.log("grid",grid)

    if (args.requestType === 'add' || args.requestType === 'beginEdit') {
      setTimeout(() => { SaveButton(props.GridID, 'hidden'); }, 1000);
      const calculateAmounts = () => {
        let PurchaseQuantity = parseFloat(document.getElementById('PurchaseInvoiceDetailGridPurchaseQuantity')?.value.replace(/,/g, '') || 0);
        let PurchaseRate = parseFloat(document.getElementById('PurchaseInvoiceDetailGridPurchaseRate')?.value.replace(/,/g, '') || 0);
        let TaxPercent = parseFloat(document.getElementById('PurchaseInvoiceDetailGridTaxPercent')?.value.replace(/,/g, '') || 0);
        let PurchaseAmount = PurchaseQuantity * PurchaseRate;
        let TaxAmount = PurchaseAmount * (TaxPercent / 100);
        let TotalAmount = PurchaseAmount + TaxAmount;
        setTimeout(() => {
          if (document.getElementById('PurchaseInvoiceDetailGridPurchaseAmount')) document.getElementById('PurchaseInvoiceDetailGridPurchaseAmount').value = parseFloat(PurchaseAmount.toFixed(2));
          if (document.getElementById('PurchaseInvoiceDetailGridTaxAmount')) document.getElementById('PurchaseInvoiceDetailGridTaxAmount').value = parseFloat(TaxAmount.toFixed(2));
          if (document.getElementById('PurchaseInvoiceDetailGridTotalAmount')) document.getElementById('PurchaseInvoiceDetailGridTotalAmount').value = parseFloat(TotalAmount.toFixed(2));
          if (args.form[5]) args.form[6].ej2_instances[0].value = parseFloat(PurchaseAmount.toFixed(2));
          if (args.form[7]) args.form[10].ej2_instances[0].value = parseFloat(TaxAmount.toFixed(2));
          if (args.form[8]) args.form[12].ej2_instances[0].value = parseFloat(TotalAmount.toFixed(2));
        }, 400);
      };
      document.getElementById('PurchaseInvoiceDetailGridPurchaseQuantity')?.addEventListener('input', calculateAmounts);
      document.getElementById('PurchaseInvoiceDetailGridPurchaseRate')?.addEventListener('input', calculateAmounts);
      document.getElementById('PurchaseInvoiceDetailGridTaxPercent')?.addEventListener('input', calculateAmounts);
      document.getElementById('PurchaseInvoiceDetailGridPurchaseQuantity')?.addEventListener('keydown', calculateAmounts);
      document.getElementById('PurchaseInvoiceDetailGridPurchaseRate')?.addEventListener('keydown', calculateAmounts);
      document.getElementById('PurchaseInvoiceDetailGridTaxPercent')?.addEventListener('keydown', calculateAmounts);
    }
    if (args.requestType === 'save' || args.requestType === 'cancel') {
      setTimeout(() => { SaveButton(props.GridID, 'visible'); }, 1000);
    }
    if (args.requestType === 'save') {
      let mainData = {};
      setInputProps((prevValues) => {
        mainData = prevValues;
        console.log("prevValues",prevValues);
        return { ...prevValues };

      });
      console.log("mainData",mainData)
      let gridLength =grid.currentViewData.length
      let data = {
        // MAIN HEADER - PurchaseInvoice
        PurchaseInvoiceID: mainData.PurchaseInvoiceID.value,
        CompanyID: mainData.CompanyID.value,
        PurchaseInvoiceDate: moment(mainData.PurchaseInvoiceDate.value).format('DD-MMM-YY'),
        CostCenterID: mainData.CostCenter.value.id,
        AccountIDVendor: mainData.AccountTitleVendor.value.id,
        AccountIDExpense: mainData.AccountTitleExpense.value.id,
        PaymentDays: mainData.PaymentDays.value,
        ReferenceInvoiceNo: mainData.ReferenceInvoiceNo.value,
        TRNNo: mainData.TRNNo.value,
        PreparedBy: mainData.PreparedBy.value,
        // DETAIL - PurchaseInvoice_Detail
        ProductID: args.data.ProductID,
        PurchaseQuantity: args.data.PurchaseQuantity,
        PurchaseRate: args.data.PurchaseRate,
        PurchaseAmount: args.data.PurchaseAmount,
        TaxPercent: args.data.TaxPercent,
        TaxAmount: args.data.TaxAmount,
        TotalAmount: args.data.TotalAmount,
        PurchaseInvoiceDetailID: args.data.PurchaseInvoiceDetailID,
        params:{
          CompanyID: mainData.CompanyID.value,
          ToDate:moment(mainData.PurchaseInvoiceDate.value).format('DD-MMM-YY'),
          PurchaseInvoiceID: mainData.PurchaseInvoiceID.value,
          FromDate:'01-Jan-01',
        }
      };
      console.log("data",data)
      if (args.action === 'add') {
        const response = data.PurchaseInvoiceID == undefined ? await PurchaseInvoiceService.addPurchaseInvoice(data) : await PurchaseInvoiceService.addPurchaseInvoiceDetail(data);
        updateMainSecionsValue({
          PurchaseInvoiceID: { value: response.data.PurchaseInvoiceID }
        });
        setDataSourceState(response.data.Recordsets.recordset);
        
        setTimeout(()=>document.getElementById('PurchaseInvoiceDetailGrid_add').click(),100)
      }
      if(args.action == 'edit' && data.PurchaseInvoiceID){
        const response =  await PurchaseInvoiceService.editPurchaseInvoiceDetail(data);
        console.log(response)
          
      
        setDataSourceState(response.data.Recordsets.recordset);
        setTimeout(() => {
          let  rowsInd = args.rowIndex +1;
    if(rowsInd < gridLength){
          selectRowByID(rowsInd)
          startEdit() 
   }
         }, 300);
      }
    }
  };

  // Utility to control Save button visibility
  const SaveButton = (GridID, visibility) => {
    const btn = document.querySelector(`#${GridID}Grid_dialogEdit_wrapper > .e-footer-content button.e-control.e-btn.e-lib.e-primary.e-flat`);
    if (btn) btn.style.visibility = `${visibility}`;
  };

  return (
    <div onKeyDown={(e) => e.stopPropagation()}>
      <StructuredGenerate mainProps={props} title={`Purchase Invoice ${props.isAdd ? `Add` : `Edit`}`} Inputs={inputsList} />
      <DynamicInputGrid
        Id='PurchaseInvoiceDetail'
        ColumnsList={BelowGridColumns}
        GridDataSource={[
          {
            DataSourceType: inputProps.CallBelowGridDataSource.value === true ? 'Function' : 'REST',
            DataSource: () => PurchaseInvoiceService.PurchaseInvoiceDetail(moment(inputProps.PurchaseInvoiceDate.value).format('DD-MMM-YY'), inputProps.PurchaseInvoiceID.value),
          }
        ]}
        DefaultSortedColumnName={'PurchaseInvoiceDetailPurchaseInvoiceID'}
        ListActionComplete={actionComplete}
        ToolbarClicking={(e) => { }}
        AllowTemplate={false}
        ToolbarOption={['Add', 'Edit', 'Delete', 'Update', 'Cancel']}
        AllowGrouping={false}
        AllowExcelExport={false}
        AllowPdfExport={false}
        ShowColumnChooser={false}
        AllowPaging={true}
        AllowDataBound={false}
        ListSecurity={'ListSecurity'}
        EditSecurity={true}
        DefaultSortedColumnSort={'Descending'}
        FilterColumns={[]}
        GroupColumns={[]}
        GridEditSettingMode={'Normal'}
        GridEditSettingHeaderTemplate={'<p></p>'}
        GridSumColumns={['PurchaseAmount', 'PurchaseQuantity', 'TotalAmount']}
        AllowGridSum={true}
        FooterSumCaption={['PurchaseAmount', 'PurchaseQuantity', 'TotalAmount']}
        {...props}
        
      ></DynamicInputGrid>
                  <AddNewDialog 
              Route={'Product'} 
              Security={'Product'} 
              onClosed={onClosing} 
              RefName={'ProductName'}
                Caption={'ADD NEW PRODUCT'}
              />
    </div>
  );
};

export default PurchaseInvoiceAdd;
